// @flow
import React, { Component } from 'react';
import {
  PartnerInfoCard,
  PartnerInfoBigBlockDiv,
  CommissionRateDiv,
  PartnerInfoBigBlockH5,
  PartnerInfoBigBlockP,
  PartnerInfoSmallBlockDiv,
  PartnerInfoDefaultMerchantFeeH5,
  PartnerInfoMerchantFeesDiv
} from './InformationStyles';
import { type ReferralDetails, type Currency } from '../../../utilities/types';
import { formatCurrency } from '../../../utilities/numberFormatting';
import InfoTooltip from '../../../components/InfoTooltip';

type Props = {
  referralDetails: ReferralDetails,
  partnerCurrency: Currency,
  activeTooltip: ?string,
  showTooltip: (tooltip: string) => void
};

export default class PartnerInfoBlock extends Component<Props> {
  render() {
    return (
      <PartnerInfoCard>
        <PartnerInfoBigBlockDiv>
          <CommissionRateDiv>
            <PartnerInfoBigBlockH5>
              merchant commission rate{' '}
              <InfoTooltip
                message="This is the percentage of referred merchants' fees that you will receive"
                showTooltip={this.props.showTooltip}
                activeTooltip={this.props.activeTooltip}
                tooltipName="MERCHANT_COMMISSION_TOOLTIP"
                smallIcon
              />
            </PartnerInfoBigBlockH5>
            <PartnerInfoBigBlockP>
              {Number(this.props.referralDetails.commission_percentage_rate)}%
            </PartnerInfoBigBlockP>
          </CommissionRateDiv>

          {/* TODO: text */}
          <CommissionRateDiv>
            <PartnerInfoBigBlockH5>
              partner commission rate{' '}
              <InfoTooltip
                message="This is the percentage of partners' referred merchants' fees you will receive"
                showTooltip={this.props.showTooltip}
                activeTooltip={this.props.activeTooltip}
                tooltipName="PARTNER_COMMISSION_TOOLTIP"
                smallIcon
              />
            </PartnerInfoBigBlockH5>
            <PartnerInfoBigBlockP>
              {Number(
                this.props.referralDetails.partner_commission_percentage_rate
              )}
              %
            </PartnerInfoBigBlockP>
          </CommissionRateDiv>
        </PartnerInfoBigBlockDiv>

        <PartnerInfoSmallBlockDiv>
          <PartnerInfoDefaultMerchantFeeH5>
            default merchant fees
          </PartnerInfoDefaultMerchantFeeH5>

          <PartnerInfoMerchantFeesDiv>
            <h5>transaction fee</h5>
            <p>
              {formatCurrency(
                this.props.referralDetails.transaction_fee,
                this.props.partnerCurrency
              )}
            </p>
          </PartnerInfoMerchantFeesDiv>

          <PartnerInfoMerchantFeesDiv>
            <h5>transaction fee percent</h5>
            <p>{Number(this.props.referralDetails.transaction_fee_percent)}%</p>
          </PartnerInfoMerchantFeesDiv>
        </PartnerInfoSmallBlockDiv>
      </PartnerInfoCard>
    );
  }
}
